/**
 * Created by glenn on 7/25/2017.
 */
import React = require("react");
import {connect} from 'react-redux'
import {iState, setData, store} from './store';
import {getRoute} from 'webmapsjs/dist/api/npmrds';
import {iExtentInner} from "../../api/npmrds/npmrdsStore";
import * as fixDate from 'webmapsjs/dist/reactComponents/helpers/dateFormat';
import {ACTION_SET_DATA, ACTION_SET_WAITING} from './actions';


interface iCallback {
    extent: iExtentInner;
    start: string;
    end: string;
    road: string;
    direction: string;
    disabled: boolean;
    version: number;
}

class _Generate extends React.Component<{ c: iCallback, callback: (e: iCallback) => any}, null> {

    render() {
        return <button disabled={this.props.c.disabled} onClick={() => {
            this.props.callback(this.props.c)
        }}>Generate Heatmap</button>
    }
}

const mapStateToProps = (state: iState) => {

    let c: iCallback = {
        extent: state.extent,
        start: null,
        end: null,
        road: null,
        direction: null,
        disabled: state.roadIndex < 0 || state.roadIndex == null,
        version: state.startEndDate.version
    };

    if (state.startEndDate.start && state.startEndDate.end) {
        c['start'] = fixDate.dateToString(state.startEndDate.start);
        c['end'] = fixDate.dateToString(state.startEndDate.end);
    }

    if (!c.disabled) {
        c.road = state.roads[state.roadIndex].number;
        c.direction = state.roads[state.roadIndex].direction;
    }

    return {
        c: c
    }
};

export const Generate = connect(
    mapStateToProps,
    (dispatch) => {
        return {
            callback: (e: iCallback) => {
                dispatch({type: ACTION_SET_WAITING, waiting: true});
                getRoute(e.road, e.direction, e.version, (d) => {
                        setData(d);
                        dispatch({type: ACTION_SET_WAITING, waiting: false});
                        // dispatch({type: ACTION_SET_DATA, data: d});
                    }, {
                        extent: {
                            coordinates: e.extent.coordinates
                        },
                        startEnd: {
                            start: e.start,
                            end: e.end
                        }
                    },
                    (err) => {
                        console.log(err);
                        dispatch({type: ACTION_SET_WAITING, waiting: false});
                    });
            }
        }
    }
)(_Generate);
